import {H2Neutral50, H3, H2, PNeutral50, PNoMargin, PMarginSm} from '@/typography';
import Container from '@/container';
import {Col, Row, Grid} from '@/grid';
import {
  withMarginBottomDoubleXlToXl,
  withMarginBottomSm,
  withMarginBottomXl,
  withMarginTopMd,
  withMarginBottomMd,
  withIsPaddedRightMd
} from '@/hocs/withSpacing';
import {
  withBgNeutral900,
  withNeutral50,
  withNeutral500,
  withNeonVioletFlowers
} from '@/hocs/withColors';
import {withMd, withPNoMargin, withBoldWeight, withXSmall} from '@/hocs/withFontType';
import {GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import Link from '@/links';
import styles from '@/content/shared/quote.module.scss';
import PictureWrapper from '@/ui/images-wrapper';
import {BreakVisibleInDesktop} from '@/breaks';
import {SectionPadding} from '@/section';

const imgPath_Kristi = '/static/images/security/';

const Neutral900Section = withBgNeutral900(SectionPadding);
const DivMargined = withMarginBottomDoubleXlToXl('div');
const LeftCenteredMargined = withMarginBottomSm(withTextLeftToCenter(H2Neutral50));
const DivMarginedBottomSm = withMarginBottomSm('div');
const PNeutral50MarginSm = withIsPaddedRightMd(withXSmall(withNeutral50(PMarginSm)));
const DivMarginedBottomXl = withMarginBottomXl('div');
const DivMarginedMd = withMarginTopMd(withMarginBottomMd('div'));
const SubP = withMd(withBoldWeight(withNeutral500(withPNoMargin(PNeutral50))));
const NeonVioletFlowersSpan = withNeonVioletFlowers('span');
const H2Neutral50MarginSm = withMarginBottomSm(withBoldWeight(withXSmall(withNeutral50(H2))));

const imagePath = '/static/images/security/logos/';
const Logos = [
  {
    imageUrl: 'iso-27001',
    title: 'ISO/IEC 27001',
    copy: (
      <>
        Information Security Management System <BreakVisibleInDesktop />
        (ISMS){' '}
      </>
    ),
    linkUrl: '/static/downloads/ISO_27001_Certification.pdf?1.0',
    linkCopy: 'Download certificate'
  },
  {
    imageUrl: 'iso-27017',
    title: 'ISO/IEC 27017',
    copy: 'Security Controls for the Provision and Use of Cloud Services',
    linkUrl: '/static/downloads/ISO_27017_Certification.pdf?1.0',
    linkCopy: 'Download certificate'
  },
  {
    imageUrl: 'soc-2',
    title: 'SOC 2 (Type II)',
    copy: 'Trust Services Principles',
    linkUrl: 'https://help.workable.com/hc/en-us/requests/new',
    linkCopy: 'Contact us for access'
  },
  {
    imageUrl: 'soc-3',
    title: 'SOC 3',
    copy: 'Service organization controls',
    linkUrl: '/static/downloads/SOC3_Report.pdf?1.0',
    linkCopy: 'Download certificate'
  }
];

const PartnerAssessments = () => (
  <Neutral900Section>
    <Container>
      <Grid fluid>
        <Row>
          <Col lg={5}>
            <LeftCenteredMargined>Workable protects your data at every level</LeftCenteredMargined>
            <DivMarginedBottomSm>
              <Row>
                {Logos.map(({imageUrl, title, copy, linkUrl, linkCopy}, index) => (
                  <Col lg={6} key={index}>
                    <DivMarginedMd>
                      <DivMarginedBottomSm>
                        <PictureWrapper
                          imgPath={imagePath}
                          imageUrl={imageUrl}
                          imageTypeFallback="png"
                          altImage={`${title}  icon`}
                          loading="lazy"
                        />
                      </DivMarginedBottomSm>
                      <H2Neutral50MarginSm className="heading-5">{title}</H2Neutral50MarginSm>
                      <PNeutral50MarginSm>{copy}</PNeutral50MarginSm>
                      <Link href={linkUrl} variant="cta-default-xs-light" target="_blank">
                        {linkCopy}
                      </Link>
                    </DivMarginedMd>
                  </Col>
                ))}
              </Row>
            </DivMarginedBottomSm>
          </Col>

          <Col lg={6} lgOffset={1}>
            <DivMargined>
              <GridItem>
                <BoxGrid backgroundColor="transparent" border="neutral700">
                  <DivMarginedBottomXl>
                    <PictureWrapper
                      imgPath={imgPath_Kristi}
                      imageUrl="kristi-stevens"
                      imageTypeFallback="png"
                      altImage="Kristi Stevens Picture"
                      loading="lazy"
                    />
                  </DivMarginedBottomXl>
                  <PNeutral50 className={styles.quote}>
                    “We were all scared to death about how we were going to manage [GDPR] on a
                    candidate level.
                    <NeonVioletFlowersSpan>
                      {' '}
                      Workable packaged that all nice and neat
                    </NeonVioletFlowersSpan>{' '}
                    - I was able to activate it with a nice little button.”
                  </PNeutral50>
                  <SubP>Kristi Stevens - Head of Talent, Frosch Travel</SubP>
                </BoxGrid>
              </GridItem>
            </DivMargined>
            <GridItem>
              <BoxGrid backgroundColor="var(--neonVioletFlowers)">
                <H3>Partner security assessments</H3>
                <PNoMargin>
                  As a trusted integration partner, Workable undergoes annual scoped technical
                  assessments conducted by industry leaders including Google, LinkedIn, ADP, and
                  Zoom to maintain our integration partnerships and ensure we meet their strict
                  requirements.
                </PNoMargin>
              </BoxGrid>
            </GridItem>
          </Col>
        </Row>
      </Grid>
    </Container>
  </Neutral900Section>
);

export default PartnerAssessments;
